module.exports = __webpack_public_path__ + "img/9788960511774.7cdf4882.jpg";